import { render } from "./nodataavalable.vue?vue&type=template&id=477816df"
import script from "./nodataavalable.vue?vue&type=script&lang=js"
export * from "./nodataavalable.vue?vue&type=script&lang=js"

import "./nodataavalable.vue?vue&type=style&index=0&id=477816df&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__